import React, { useState, useEffect } from 'react';

import { GeneralModal, FormInput_textarea, Button } from "components";

import { func_validation } from "functions";

import "assets/scss/components/modals/textareaModal.scss";



export function TextareaModal(props) {
    // Props
    const { 
        title,
        placeholder,
        confirmButtonText,
        isModalVisible,
        inputValue
    } = props;

    // Validate Props
    let title_validated = func_validation.isStringTrimNotEmpty(title)? title: "";
    let placeholder_validated = func_validation.isStringTrimNotEmpty(placeholder)? placeholder: "";
    let confirmButtonText_validated = func_validation.isStringTrimNotEmpty(confirmButtonText)? confirmButtonText: "";

    // States
    const [value, setValue] = useState(inputValue);

    function updateParentState(isVisible, isConfirm) {
        if (props.updateParentState &&
            (isVisible != isModalVisible))
            props.updateParentState(isVisible);

        let value_formatted = isConfirm? value: inputValue;
        setValue(value_formatted);
    }

    function handleOnConfirm() {
        if (props.handleOnConfirm)
            props.handleOnConfirm(value);
    }

    return (
        <GeneralModal
            isModalVisible={isModalVisible}
            updateParentState={updateParentState}
            modalWapperClassName={"component-textareaModal"}

            headerClassName={"component-textareaModal-header"}
            headerTitleClassName={"component-textareaModal-header-title"}
            headerCloseClassName={"component-textareaModal-header-close"}

            bodyClassName={"component-textareaModal-body"}
            title={title_validated}
            bodyFooter={(
                <FormInput_textarea
                    className={"component-textareaModal-textarea"}
                    customInputClassName={"component-textareaModal-textarea-input"}

                    inputValue={value}
                    inputPlaceholder={placeholder_validated}
                    isInputOptional

                    propagateValueChange={(stateName, value) => { setValue(value); }}
                    isMarginBtmOptional isLabelOptional
                />
            )}

            footerClassName={"component-textareaModal-footer"}
            footerConfirmWrapperClassName={"component-textareaModal-footer-confirmWrapper"}
            footerConfirmClassName={"component-textareaModal-footer-confirm"}
            confirmButtonText={confirmButtonText_validated}
            handleOnConfirm={handleOnConfirm}
            isConfirmButtonVisible
        />
    );
}